import { shiftEditorViewState } from "..";
import { mutatorAction } from "satcheljs";

export default mutatorAction("setTimeOffReasonIdTimeoff", function setTimeOffReasonIdTimeoff(timeOffReasonId: string) {
    if (shiftEditorViewState().timeoff) {
        shiftEditorViewState().timeoff.timeOffReasonId = timeOffReasonId;
    }
});
